import { serializable, alias, primitive } from 'serializr';

export class Address {
  @serializable
  name?: string;

  @serializable
  category?: string;

  @serializable
  city?: string;

  @serializable
  street?: string;

  @serializable
  province?: string;

  @serializable(alias('postal_code', primitive()))
  postalCode?: string | null;

  @serializable
  country?: string;

  @serializable(alias('country_code', primitive()))
  countryCode?: string;

  @serializable
  latitude?: string;

  @serializable
  longitude?: string;

  @serializable
  map?: string;

  @serializable(alias('province_code'))
  provinceCode?: string;

  constructor() {
    if (this?.getFormattedAddress) {
      this.getFormattedAddress = this.getFormattedAddress.bind(this);
    }
  }

  getFormattedAddress?(): string {
    let addressParts = [];

    if (this?.city) {
      addressParts.push(this.city);
    }
    if (this?.country) {
      addressParts.push(this.country);
    }
    if (this?.postalCode) {
      addressParts.push(this.postalCode);
    }

    // If all fields are undefined or empty, return an empty string
    if (addressParts.length === 0) {
      return '';
    }

    return addressParts.join(', ');
  }
}
